import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ActiveNumber extends Component {
    state = {
        currentNumber: 0,
        showNumber: 0
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let { delay = 300, value = 0, formatNumber = false } = this.props;
        let time = delay / value;
        let step, stepCount;
        // 最短每30ms为一帧
        if (time > 30) {
            step = value / delay;
            stepCount = delay / time;
        } else {
            time = 30;
            stepCount = delay / 30;
            step = value / stepCount;
        }
        let decrease = step / stepCount;
        let change = step * 1.5;
        this.interval = setInterval(() => {
            change = change > 1 ? change : 1;
            let currentNumber = this.state.currentNumber + change;
            currentNumber = currentNumber > value ? value : currentNumber;
            if (currentNumber >= value) {
                clearInterval(this.interval);
            }
            this.setState({ currentNumber });
            const showNumber = currentNumber.toString().split('.')[0];
            if (formatNumber) this.setState({ showNumber: this.fomatNumber(showNumber) });
            else this.setState({ showNumber });
            change -= decrease;
        }, time)
    }

    componentWillMount() {
        clearInterval(this.interval);
    }

    /**
     * 数字每三位加逗号
     * @param numberOrString
     * @returns {string}
     */
    fomatNumber = numberOrString => {
        let str = String(numberOrString);
        let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
        return str.replace(reg, "$1,");
    }

    render() {
        let { className = '' } = this.props;
        return (
            <span className={className}>
                {this.state.showNumber}
            </span>
        );
    }
}

ActiveNumber.propTypes = {
    className: PropTypes.string,
    delay: PropTypes.number,
    formatNumber: PropTypes.bool,
    value: PropTypes.number.isRequired
};

ActiveNumber.defaultProps = {
    className: '',
    delay: 300,
    formatNumber: false,
    value: 0
};

export default ActiveNumber;